import { Link } from "@inertiajs/react"
import AppLayout from "@/components/AppLayout"
import PageTitle from "@/components/PageTitle"
import { Button } from "@/components/ui/Button"
import PlanCard from "./components/PlanCard"
import { PLANS } from "./data"

export default function PurchasePlans() {
  return (
    <AppLayout
      header={<PageTitle title="Purchase Plan" subtitle="What you plan to buy, from whom, and by when." />}
      headerActions={
        <Button asChild>
          <Link href="/wireframes/purchase/plans/new">New plan</Link>
        </Button>
      }
    >
      <div className="flex max-w-4xl flex-col gap-4">
        {PLANS.map((plan) => (
          <PlanCard key={plan.id} plan={plan} />
        ))}
      </div>
    </AppLayout>
  )
}
